<template>
  <div class="fee-total">
    <!-- 총 수수료 -->
    <v-layout justify-space-between class="color--orange total-row">
      <v-flex class="d-flex align-center">
        카드배달 수수료
      </v-flex>
      <v-flex class="text-right amount">
        {{ $filters.commaFormat(data.totalDeductionAmount) }} 원
      </v-flex>
    </v-layout>

    <!-- 소스별 수수료 내역 -->
    <template v-for="payment in data.paymentsDetail">
      <template v-for="amountDetail in payment.amountDetails">
        <template v-if="amountDetail.title === '수수료'">
          <v-layout 
            v-for="detail in amountDetail.data" 
            :key="detail.name"
            justify-space-between 
            class="subtitle detail-row color--nice-grey"
          >
            <v-flex class="d-flex align-center">
              {{ detail.name }}
            </v-flex>
            <v-flex class="text-right">
              {{ $filters.commaFormat(detail.amount) }}원 ({{ detail.percentage }}%)
            </v-flex>
          </v-layout>
        </template>
      </template>
    </template>

    
  </div>
</template>

<script>
import { sumByPropertyName } from '@/util/mathUtil'

export default {
  props: ['data'],
  methods: {
    sumByPropertyName,
  },
}
</script>

<style lang="scss" scoped>
.fee-total {
  .total-row {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    
    .amount {
      font-size: 20px;
      font-weight: 700;
    }
  }

  .detail-row {
    margin: 12px 0;
    font-size: 15px;
    padding-left: 15px;
  }

  img.icon {
    width: 22px;
    margin-right: 8px;
  }

}
</style>
